import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useHistory, useLocation } from 'react-router-dom';

import OnboardingShell, { useOnboardingStyles } from './OnboardingShell';
import GenericState from '../../MyComponents/GenericLoadingErrorState/GenericState';
import { parseQuery } from '../../common/utils';
import userApi from '../../Api/userApi';
import store from '../../redux/store';
import { showError, updateUserPreferences } from '../../redux/actions';
import { PROFILE_LINK } from '../../common/urlLinks';
import { cx } from '../Home/HomeDashboard/dashboardStyles';

/**
 * Landing page of the email activation link: validates the address, then
 * resumes the checkout that was waiting on it, if any.
 */
const VerifyEmailPage = () => {
    const classes = useOnboardingStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const queryObj = parseQuery(location.search);
        if (!queryObj.id || !queryObj.email) {
            setIsLoading(false);
            setValidated(false);
            return;
        }
        setIsLoading(true);
        userApi
            .verifyEmail({ id: queryObj.id, email: queryObj.email })
            .then((res) => {
                if (res.data === true) {
                    setValidated(true);
                    return userApi.getExtendedProfile();
                }
                setValidated(false);
                return Promise.resolve();
            })
            .then((response) => {
                if (response) store.dispatch(updateUserPreferences(response.data.preferences));
                setIsLoading(false);
                const redirectState = window.localStorage.getItem('tempCheckoutSession');
                if (redirectState) {
                    const redirectObj = JSON.parse(redirectState);
                    if (redirectObj) {
                        history.push(
                            `/onboarding?step=${redirectObj.step}&subscription=${redirectObj.subscription}&billAnnual=${redirectObj.billAnnual}&billEur=${redirectObj.billEur}`
                        );
                    }
                }
            })
            .catch((err) => {
                console.error('Unable to validate email', err);
                setIsLoading(false);
                setValidated(false);
                store.dispatch(showError('GENERIC_ERROR'));
            });
    }, [location, history]);

    let statusId;
    if (isLoading) {
        statusId = 'onboarding.verifyEmail.verifying';
    } else if (validated) {
        statusId = 'onboarding.verifyEmail.update';
    } else {
        statusId = 'onboarding.verifyEmail.invalid';
    }

    return (
        <OnboardingShell title={<FormattedMessage id={statusId} />}>
            <div className={cx(classes.card, classes.centered)}>
                {isLoading ? (
                    <GenericState isLoading={true} inline={true} />
                ) : (
                    <Link to={PROFILE_LINK} className={classes.primary}>
                        <FormattedMessage id="profile" />
                        <span aria-hidden="true">→</span>
                    </Link>
                )}
            </div>
        </OnboardingShell>
    );
};

export default VerifyEmailPage;
